export default "/_next/static/09edd58fb2539bf19c567a452319e792.png";